/*  ========================================================================
    # Scripts - Header Menu Mobile
    ========================================================================  */

const HeaderMenuMobile = {
  cfg: {
    button: {
      element: document.querySelector('.c-header__burger'),
      activeClass: 'c-header__burger--active'
    },
    menu: {
      element: document.querySelector('.c-header-menu-mobile'),
      activeClass: 'c-header-menu-mobile--active',
      backdrop: document.querySelector('.c-header-menu-mobile__backdrop'),
      entries: document.querySelectorAll('.c-header-menu-mobile__entry'),
      entryActiveClass: 'c-header-menu-mobile__entry--active',
      submenuButtonClass: 'c-header-menu-mobile__submenu-button'
    },
    page: {
      main: document.querySelector('main'),
      footer: document.querySelector('.c-footer')
    }
  },

  /**
   * Show/hide the mobile menu.
   */
  handlerShowHide() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
      this.cfg.button.element.setAttribute('aria-expanded', 'false');
      this.cfg.page.main.removeAttribute('inert');
      this.cfg.page.footer.removeAttribute('inert');
    } else {
      document.body.style.overflow = 'hidden';
      this.cfg.button.element.setAttribute('aria-expanded', 'true');
      this.cfg.page.main.setAttribute('inert', '');
      this.cfg.page.footer.setAttribute('inert', '');
    }
    this.cfg.button.element.classList.toggle(this.cfg.button.activeClass);
    this.cfg.menu.element.classList.toggle(this.cfg.menu.activeClass);
  },

  /**
   * Show/hide the submenus.
   *
   * @param {Object} entryObject
   */
  handlerSubmenus(entryObject) {
    if (entryObject.submenuButton) {
      entryObject.submenuButton.addEventListener('click', () => {
        if (entryObject.submenuButton.getAttribute('aria-expanded') === 'true') {
          // Collapse
          entryObject.entry.classList.remove(this.cfg.menu.entryActiveClass);
          entryObject.submenuButton.setAttribute('aria-expanded', 'false');
          entryObject.submenu.setAttribute('aria-hidden', 'true');
          entryObject.submenu.setAttribute('inert', '');
        } else {
          // Expand
          entryObject.entry.classList.add(this.cfg.menu.entryActiveClass);
          entryObject.submenuButton.setAttribute('aria-expanded', 'true');
          entryObject.submenu.setAttribute('aria-hidden', 'false');
          entryObject.submenu.removeAttribute('inert');
        }
      });
    }
  },

  /**
   * Creates an object for each menu entry.
   */
  entries() {
    this.cfg.menu.entries.forEach(entry => {
      const entryObject = {
        entry,
        submenuButton: entry.querySelector(`.${this.cfg.menu.submenuButtonClass}`) || false,
        submenu: entry.querySelector('.c-header-menu-mobile__submenu') || false
      };

      this.handlerSubmenus(entryObject);
    });
  },

  /**
   * Initialize.
   */
  init() {
    this.cfg.button.element.addEventListener('click', () => this.handlerShowHide());
    this.cfg.menu.backdrop.addEventListener('click', () => this.handlerShowHide());
    this.entries();
  }
};

export default HeaderMenuMobile;
